import GenericService from './genericService';
import axiosInstance from '../utils/axios';

class CustomerlocationService extends GenericService {
  constructor() {
    super('/customer_locations', axiosInstance);
  }
}

export default new CustomerlocationService(); 